type EventName = "signup" | "conversion";

type EventParams = {
  groups?: string | string[];
  send_to?: string | string[];
  event_callback?: () => void;
  event_timeout?: number;
};

declare let gtag: (
  command: "event",
  eventName: EventName,
  eventParams: EventParams,
) => void;

export const gTag = ({
  eventName,
  eventParams,
}: {
  eventName: EventName;
  eventParams: EventParams;
}) => {
  try {
    gtag("event", eventName, eventParams);
  } catch (error) {
    console.error("[gtag] Error tracking event:", error);
  }
};
